import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-command",
  "use": "icon-type-command-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-type-command\">\n    <g clip-path=\"url(#icon-type-command_clip0)\">\n        <path d=\"M0.166992 5.83337L25.5003 5.83338L32.167 16.5L25.5003 27.1667H0.166992L6.83366 16.5L0.166992 5.83337Z\" />\n    </g>\n    <defs>\n        <clipPath id=\"icon-type-command_clip0\">\n            <rect width=\"32\" height=\"32\" transform=\"translate(0.166992 0.5)\" />\n        </clipPath>\n    </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol